import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../../components/Button';
import { Modal } from '../../../../../../components/Modal';
import { WarningIcon } from '../../../../../../components/svgs/icons/WarningIcon';
import { bs } from '../../../../../../styles/styles';

interface ResetSuggestionEditedContentModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	isConfirmDisabled?: boolean;
}

export const ResetSuggestionEditedContentModal: React.FC<ResetSuggestionEditedContentModalProps> = ({
	isOpen,
	onRequestClose,
	onConfirm,
	isConfirmDisabled,
}) => {
	return (
		<Modal isOpen={isOpen} onRequestClose={onRequestClose}>
			<div className={css(bs.flex, bs.flexCol, bs.gap4, bs.p4)}>
				<div className={css(bs.flex, bs.itemsCenter, bs.gap3)}>
					<WarningIcon />
					<h2 className={css(bs.textLg, bs.fontBold)}>Reset Edited Content?</h2>
				</div>
				<p>This post&apos;s edited content will be lost. Are you sure you want to continue with AI generation?</p>
				<div className={css(bs.flex, bs.gap2, bs.justifyEnd)}>
					<Button label='Cancel' onClick={onRequestClose} kind='reverse' />
					<Button label='Continue' onClick={onConfirm} kind='destructive' disabled={isConfirmDisabled} />
				</div>
			</div>
		</Modal>
	);
};
